export const FETCH_PROFILE_IMG = 'FETCH_PROFILE_IMG';
export const MAKE_NEW_LIST = 'MAKE_NEW_LIST';
export const DELETE_LIST = 'DELETE_LIST';
export const ADD_TASK_TO_LIST = 'ADD_TASK_TO_LIST';
export const UPDATE_TASK_TO_LIST = 'UPDATE_TASK_TO_LIST';
